import * as Actions from 'app/store/actions/multipleCompanies/multipleCompanies.actions';

const initialState = {
	entities: null,
	companiesPayload: null,
	searchMember: '',
	routeParams: {},
	contactDialog: {
		type: 'new',
		props: {
			open: false
		},
		data: null
	},
	companyName:'',
	//createHeadAdminList: [{id:'1', imgUrl:'assets/images/avatars/Abbott.jpg', name: "Abbot Morgan", email: "abbott.morgan@ad-hzm.co.jp"}],
	createHeadAdminList: [],
	headAdminName: '',
	setImgHeadAdmin: '',
	handleFilesUpload: [],
	handleFilesUploadList: [],
	handleDetails:[],
	createCompany:[],
	flagClickCompanies: false,
	searchFilterCheckbox: [],
	handleImageEdit:undefined,
	handleEditDetails: [],
	isEdit: false,
	handleUpdateCompany: [],
	handleRemoveCompany:[],
	handleActivateCompany:[],
	companyResponse:null,
	getHeadAdmin:[],
	removeHeadAdmin: [],
	clickRemoveHeadAdmin: false,
	clickCreateHeadAdmin: false,
	clickRemoveCompany: false,
	validDomain: true,
	searchCompanyUsers: null,
	createCompanyMode: false,
	isSubmitedMode: false,
	createCompanyFlag: false,
	sideMenuItems: null,
	createSideMenuItems:[],
	getSideMenuItems:[],
};

const multipleCompaniesReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_COMPANY: {

			//::Newest to Oldest
			const companiesCreatedDate = action.payload.data.map((users)=> users)
			const newOrder = companiesCreatedDate.sort(function(a, b){return new Date(b.created_date) - new Date(a.created_date)});
			//console.log('COMPANIESS', newOrder)
			return {
				...state,
				entities: newOrder,
				companiesPayload : action.payload,
			};
		}
		case Actions.CREATE_HEAD_ADMIN_LIST:{
			return{
				...state,
				createHeadAdminList: [...state.headAdminList, action.payload],
			}
		}
		case Actions.MEMBER_SEARCH_TEXT: {
			return {
				...state,
				searchMember: action.searchMember,
			};
		}
		case Actions.OPEN_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: true
					},
					data: null
				}
			};
		}
		case Actions.CLOSE_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: false
					},
					data: null
				}
			};
		}
		case Actions.OPEN_EDIT_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'edit',
					props: {
						open: true
					},
					data: action.data
				}
			};
		}
		case Actions.CLOSE_EDIT_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'edit',
					props: {
						open: false
					},
					data: null
				}
			};
		}
		case Actions.HANDLE_DETAILS: {
			return {
				...state,
				handleDetails: action.payload,
			};
		}
		case Actions.COMPANY_NAME: {
			return {
				...state,
				companyName: action.payload,
			};
		}
		case Actions.HEAD_ADMIN_NAME:{
			return{
				...state,
				headAdminName: action.payload
			}
		}
		case Actions.SET_IMG_HEAD_ADMIN:{
			return{
				...state,
				setImgHeadAdmin: action.payload
			}
		}
		case Actions.HANDLE_FILES_UPLOAD:{
			return{
				...state,
				handleFilesUpload: action.payload
			}
		}
		case Actions.HANDLE_FILES_UPLOAD_LIST:{
			return{
				...state,
				handleFilesUploadList: action.payload
			}
		}
		case Actions.CREATE_COMPANY:{
			return{
				...state,
				createCompany: action.payload,
			}
		}
		case Actions.FLAG_CLICK_COMPANIES:{
			return {
				...state,
				flagClickCompanies: action.payload,
			}; 
		}
		case Actions.SET_FILTER_CHECKBOX: {
			return {
				...state,
				searchFilterCheckbox: action.payload,
			};
		}
		case Actions.HANDLE_IMAGE_EDIT: {
			//console.log('REDUCERS IMAGE -->', action.payload)
			return {
				...state,
				handleImageEdit: action.payload,
			};
		}
		case Actions.HANDLE_EDIT_DETAILS: {
			console.log('REDUCER FROM ACTION UPDATE CLICK', action.payload)
			return {
				...state,
				handleEditDetails: action.payload,
				// isEdit : true
			};
		}
		case Actions.HANDLE_UPDATE_COMPANY: {
			return {
				...state,
				handleUpdateCompany: action.payload,
			};
		}
		case Actions.HANDLE_ACTIVATE_COMPANY: {
			return {
				...state,
				handleActivateCompany: action.payload,
			};
		}
		case Actions.HANDLE_REMOVE_COMPANY: {
			return {
				...state,
				handleRemoveCompany: action.payload,
			};
		}
		case Actions.IS_EDITABLE: {
			return {
				...state,
				isEdit: action.payload,
			};
		}
		case Actions.ADD_COMPANY_BUTTON: {
			return {
				...state,
				handleEditDetails: [],
				isEdit: false,
			};
		}
		case Actions.HANDLE_COMPANY_RESPONSE: {
			console.log('RECEBENDO NO REDUCER COMPANY RESPONSE', action.payload)
			return {
				...state,
				companyResponse: action.payload,
			};
		}
		case Actions.GET_HEAD_ADMIN: {
			return {
				...state,
				getHeadAdmin: action.payload,
			};
		}
		case Actions.REMOVE_HEAD_ADMIN: {
			return {
				...state,
				removeHeadAdmin: action.payload,
			};
		}
		case Actions.CLICK_REMOVE_HEAD_ADMIN: {
			return {
				...state,
				clickRemoveHeadAdmin: action.payload,
			};
		}
		case Actions.CLICK_CREATE_HEAD_ADMIN: {
			console.log('REDUCERSSS CREATE HEAD ADMIN', action.payload)
			return {
				...state,
				clickCreateHeadAdmin: action.payload,
			};
		}
		case Actions.CLICK_REMOVE_COMPANY: {
			return {
				...state,
				clickRemoveCompany: action.payload,
			};
		}
		case Actions.VALID_DOMAIN: {
			return {
				...state,
				validDomain: action.payload,
			};
		}
		case Actions.SEARCH_COMPANY_USERS: {
			return {
				...state,
				searchCompanyUsers: action.payload,
			};
		}
		case Actions.CREATE_COMPANY_MODE: {
			return {
				...state,
				createCompanyMode: action.payload,
			};
		}
		case Actions.IS_SUBMITED_MODE: {
			return {
				...state,
				isSubmitedMode: action.payload,
			};
		}
		case Actions.CREATE_COMPANY_FLAG: {
			return {
				...state,
				createCompanyFlag: action.payload,
			};
		}
		case Actions.SIDE_MENU_ITEMS: {
			return {
				...state,
				sideMenuItems: action.payload,
			};
		}
		case Actions.POST_SIDE_MENU_ITEMS: {
			return {
				...state,
				createSideMenuItems: action.payload,
			};
		}
		case Actions.GET_SIDE_MENU_ITEMS: {
			return {
				...state,
				getSideMenuItems: action.payload,
			};
		}
		case Actions.RESET_SIDE_MENU_ITEMS: {
			return {
				...state,
				getSideMenuItems: initialState.getSideMenuItems,
			};
		}

		default: {
			return state;
		}
	}
};

export default multipleCompaniesReducer;
